// financeLayout.js — where the Subscriptions card renders on the Finance tab
// (2026-10-22). It used to render on every sub-tab. Now:
//   bills    → the full card (list, Possible, Hidden, Add, "Recurring charges we found")
//   overview → one compact line, "Subscriptions $X/mo →", that opens Bills & Goals at the card
//   spending, accounts → nothing
export const SUBSCRIPTIONS_CARD_ID = 'subscriptions-card';
export function subscriptionsPlacement(subTab) {
  if (subTab === 'bills') return 'full';
  if (subTab === 'overview') return 'compact';
  return null;
}
